import React from 'react';
import { useFeatureFlags } from '@tcc/shared-data-lib';
import { importFromS3 } from '../../utils/importFromS3';
import { useFeatureFlagsConfigs } from '../../utils/sharedData';

const S3Plugin = React.lazy(() => importFromS3('tcc-apps-marketplace-plugin'));
const MFPlugin = React.lazy(() => import('appsMarketplacePlugin/AppsMarketplacePlugin'));

export const ConnectPluginContainer = () => {
  const { featureFlags } = useFeatureFlags(useFeatureFlagsConfigs());
  const useModuleFederation = featureFlags?.['web.appsMarketplacePlugin.module-federation'];

  const ConnectPlugin = useModuleFederation ? MFPlugin : S3Plugin;

  return <ConnectPlugin shouldRenderNavBar={false} />;
};
